import { render, staticRenderFns } from "./tablePage.vue?vue&type=template&id=aa90f348&scoped=true&"
import script from "./tablePage.vue?vue&type=script&lang=js&"
export * from "./tablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa90f348",
  null
  
)

export default component.exports